import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const SharedTooltip = ({ active, payload, label, isTimestamp = false }) => {
  if (!active || !payload || !payload.length) return null;

  const sortedPayload = [...payload].sort((a, b) => b.value - a.value);
  const title = isTimestamp 
    ? new Date(label).toLocaleDateString('pl-PL') 
    : payload[0].payload.dateStr;

  return (
    <Paper sx={{ p: 1, backgroundColor: 'rgba(15, 15, 15, 0.95)', color: '#fff', border: '1px solid #444', minWidth: 230 }}>
      <Typography variant="caption" sx={{ color: '#aaa', display: 'block', mb: 1, textAlign: 'center', borderBottom: '1px solid #333' }}>
        {title}
      </Typography>
      
      {sortedPayload.map((entry, index) => {
        const data = entry.payload;
        // Obsługa różnych formatów danych meczowych z obu wykresów
        const match = data.matchInfo || (data.newMatchesByTeam ? data.newMatchesByTeam[entry.name]?.[0] : null);
        const isHome = match?.homeTeam === entry.name;
        const isAway = match?.awayTeam === entry.name;

        return (
          <Box key={index} sx={{ mb: index === sortedPayload.length - 1 ? 0 : 1.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
              <Typography sx={{ color: entry.color, fontSize: '0.85rem', fontWeight: 'bold' }}>
                {entry.name}
              </Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                {typeof entry.value === 'number' && entry.value < 1 
                  ? `${(entry.value * 100).toFixed(1)}%` 
                  : entry.value}
              </Typography>
            </Box>
            
            {match && (
              <Typography variant="caption" sx={{ display: 'block', fontSize: '0.75rem', color: '#bbb', mt: 0.2 }}>
                <span style={{ fontWeight: isHome ? '900' : 'normal', color: isHome ? '#fff' : 'inherit' }}>
                  {match.homeTeam}
                </span>
                {` ${match.result || match.score || (match.homeGoals + ':' + match.awayGoals)} `}
                <span style={{ fontWeight: isAway ? '900' : 'normal', color: isAway ? '#fff' : 'inherit' }}>
                  {match.awayTeam}
                </span>
              </Typography>
            )}
          </Box>
        );
      })}
    </Paper>
  );
};

export default SharedTooltip;